var map = {
	"./QRCode.png": "YV7y",
	"./RiskInfo.png": "iAL6",
	"./RiskInfo_Banner.png": "oOFD",
	"./banner.png": "r2LF",
	"./corner.png": "3Tfe",
	"./gongan.png": "F8Fa",
	"./logo2.png": "ZFGm",
	"./logo3.png": "wr+u",
	"./privacypolicy-banner.png": "krk7",
	"./privacypolicy.png": "UgnD",
	"./riskmanagement.png": "SJNW",
	"./termsofuse-banner.png": "c88F",
	"./termsofuse.png": "w81n",
	"./wb.png": "2B6y",
	"./wx.png": "sSOe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28rB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images \.png$
// module id = 28rB
// module chunks = 0